import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from '@/plugins/axios'
Vue.prototype.$bus = new Vue()
Vue.config.productionTip = false

import CofirmDelete from '@/components/shared/ConfirmDelete'
Vue.component('confirm-delete',CofirmDelete)

import ConfirmPopup from '@/components/shared/ConfirmPopup.vue'
Vue.component('confirm-popup', ConfirmPopup)


// Set the Authorization header with the token if it exists
const token = localStorage.getItem('auth_token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
} else {
  // Optionally, you can remove the Authorization header if no token is available
  delete axios.defaults.headers.common['Authorization']
}

import '@/assets/scss/style.scss'

import GeneralMixin from './mixins/GeneralMixin'
Vue.mixin(GeneralMixin)

import paginationMixin from './mixins/paginationMixin'
Vue.mixin(paginationMixin)

const getNumberInput = (target) => {
  if (!(target instanceof HTMLElement)) {
    return null
  }

  if (target.matches('input[type="number"]')) {
    return target
  }

  return target.closest('input[type="number"]')
}

document.addEventListener('keydown', (event) => {
  const numberInput = getNumberInput(event.target)
  if (!numberInput) {
    return
  }

  if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
    event.preventDefault()
  }
}, true)

document.addEventListener('wheel', (event) => {
  const numberInput = getNumberInput(event.target)
  if (!numberInput) {
    return
  }

  event.preventDefault()
  numberInput.blur()
}, { capture: true, passive: false })


/*temp*/


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
